import * as React from "react";

export const CrosswalkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg height="800px" width="800px" version="1.1" id="_x32_" viewBox="0 0 512 512" fill="#ffffff" {...props}>
    <g>
      <path
        className="st0"
        d="M283.58,81.258c22.438,0,40.629-18.191,40.629-40.638C324.209,18.191,306.018,0,283.58,0
		c-22.438,0-40.628,18.191-40.628,40.62C242.952,63.067,261.142,81.258,283.58,81.258z"
      />
      <path
        className="st0"
        d="M366.291,427.948c2.526-4.714,2.975-10.268,1.237-15.328l-25.673-74.39
		c-3.607-10.466-8.944-20.232-15.795-28.916l-41.676-55.109l15.284-79.52l19.739,25.068c2.432,3.105,5.588,5.579,9.186,7.214
		l51.9,23.433c3.754,1.695,8.036,1.799,11.859,0.285c3.841-1.514,6.894-4.516,8.486-8.313l0.156-0.398
		c3.035-7.283,0.009-15.673-6.981-19.35l-46.52-24.471l-19.609-40.291c-9.896-20.327-28.839-34.756-51.07-38.89l-20.18-3.754
		c-10.155-1.878-20.639-0.519-29.98,3.892l-58.768,27.749c-6.522,3.08-11.678,8.442-14.515,15.06l-26.14,61.026
		c-1.661,3.875-1.686,8.26-0.095,12.152c1.601,3.902,4.706,7.006,8.598,8.607l0.588,0.234c7.794,3.191,16.72-0.329,20.241-7.966
		l23.995-51.952l37.964-12.274l-37.628,167.212l-36.641,91.369c-2.033,5.06-1.799,10.743,0.614,15.622
		c2.413,4.896,6.79,8.52,12.04,9.991l1.583,0.432c8.425,2.352,17.37-1.289,21.755-8.858l43.432-75.021l25.881-51.346l47.22,52.116
		l34.877,73.896c3.936,8.331,13.244,12.69,22.162,10.38l0.389-0.104C359.38,436.096,363.748,432.654,366.291,427.948z"
      />
      <polygon className="st0" points="49.408,512 102.061,512 156.452,451.156 113.184,451.156 	" />
      <polygon className="st0" points="171.71,512 224.363,512 240.011,451.156 196.752,451.156 	" />
      <polygon className="st0" points="271.989,451.156 287.637,512 340.29,512 315.239,451.156 	" />
      <polygon className="st0" points="398.798,451.156 355.539,451.156 409.922,512 462.592,512 	" />
    </g>
  </svg>
);
